<!-- @Author: Yu_Bo 2023-09-06 14:29:18-->
<template>
    <div class="classify_add_eidt">
        <el-dialog class="zc_dialog_box" :visible.sync="dialogVisible" width="500px" :close-on-click-modal='false' @close="cancelBtn">
            <div slot="title">
                <div class="name">{{ title }}</div>
            </div>
            <div class="main_info">
                <div class="info_text">
                    <div class="t_left"><span>*</span>公屏名称</div>
                    <div class="t_right">
                        <el-input v-model="info.name" :clearable="true" placeholder="请输入公屏名称"></el-input>
                    </div>
                </div>
                <div class="info_text">
                    <div class="t_left"><span>*</span>自定义标识</div>
                    <div class="t_right">
                        <el-input v-model="info.screen_lable" :clearable="true" placeholder="请输入自定义标识(20字以内)"></el-input>
                    </div>
                </div>
                <div class="info_text">
                    <div class="t_left"><span>*</span>分类</div>
                    <div class="t_right">
                        <el-select v-model="info.category_id" :clearable="true" placeholder="请选择分类">
                            <el-option v-for="item in list" :key="item.value" :label="item.label" :value="numFuntion(item.value)">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="info_text">
                    <div class="t_left"><span>*</span>显示内容</div>
                    <div class="t_right">
                        <el-input 
                            v-model="info.screen_text" 
                            ref="txtInput"
                            type="textarea" 
                            :rows="4"
                            resize="none"
                            maxlength="300"
                            show-word-limit
                            @blur="handleInputBlur"
                            @focus="getCursor"
                            placeholder="请输入文本内容">
                        </el-input>
                        <el-button class="input_btn" type="text" @click="insertVariable">插入变量</el-button>
                    </div>
                </div>
                <div class="info_text">
                    <div class="t_left">排序</div>
                    <div class="t_right">
                        <el-input v-model="info.sort" :clearable="true" placeholder="请输入排序"></el-input>
                    </div>
                </div>
                <div class="info_text">
                    <div class="t_left"><span>*</span>图片</div>
                    <div class="t_right">
                        <file-upload :width="100" :height="100" type="img_1" @upload="successUpload">
                            <div class="picture_img_upload">
                                <div class="img_yes" v-if="info.background_img">
                                    <el-image :src="info.background_img" fit="scale-down"></el-image>
                                    <div class='succ_btn'>
                                        <i class="el-icon-picture-outline-round" @click.stop="playImg(info.background_img)"></i>
                                        <i class="el-icon-circle-plus-outline"></i>
                                    </div>
                                </div>
                                <div class="img_no" v-else>
                                    <i class="el-icon-plus"></i>
                                    <div>上传图片</div>
                                </div>
                            </div>
                        </file-upload>
                    </div>
                </div>
                <div class="info_text">
                    <div class="t_left">状态</div>
                    <div class="t_right">
                        <el-switch v-model="info.status" :active-value="1" :inactive-value="2"></el-switch>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <el-button class="btnBgColor_grey" size="small" @click="cancelBtn">取 消</el-button>
                <el-button class="btnBgColor_blue" size="small" type="primary" @click="affirmBtn" :loading="subLoading">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 预览图片 -->
        <img-preview ref="img"></img-preview>
    </div>
</template>

<script>
let that
import FileUpload from '@/components/file_upload/index.vue'// 上传
import ImgPreview from '@/components/img_preview/index.vue'

export default {
    components: {FileUpload,ImgPreview},
    props: {
        list:{
            type:Array,
            defaul:[]
        }
    },
    data() {
        return {
            title:'',
            dialogVisible:false,
            // 
            info:{
                name:'',
                screen_lable:'',
                category_id:'',
                screen_text:'',
                sort:'',
                background_img:'',
                status:2,
            },
            // 插入变量光标
            cursorIndex:null,
            // 
            subLoading:false
        };
    },

    computed: {},

    watch: {},

    created() {
        that = this
    },

    mounted() {},

    methods: {
        // 打开
        openDialog(info=''){
            if(info){
                that.title = '编辑公屏'
                that.info = info
            }else{
                that.title = '添加公屏'
                that.info = {
                    name:'',
                    screen_lable:'',
                    category_id:'',
                    screen_text:'',
                    sort:'',
                    background_img:'',
                    status:2,
                }
            }
            that.dialogVisible = true
        },
        // 取消
        cancelBtn(){
            that.info = {
                name:'',
                screen_lable:'',
                category_id:'',
                screen_text:'',
                sort:'',
                background_img:'',
                status:2,
            }
            that.dialogVisible = false
        },
        // 确定
        affirmBtn(){
            var obj = JSON.parse(JSON.stringify(that.info))
            if(obj.name==''){
                that.$warMsg('请输入公屏名称')
            }else if(obj.screen_lable==''){
                that.$warMsg('请输入自定义标识')
            }else if(obj.category_id==''){
                that.$warMsg('请选择分类')
            }else if(obj.screen_text==''){
                that.$warMsg('请输入显示内容')
            }else if(obj.background_img==''){
                that.$warMsg('请上传图片')
            }else if(obj.id){
                // 编辑
                that.subLoading = true
                var params = {
                    ...obj
                }
                that.$materialApi.putMaterialScreen(params,obj.id).then(res => {
                    that.subLoading = false
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.cancelBtn()
                        that.$emit('affirm')
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            }else{
                // 添加
                that.subLoading = true
                var params = {
                    ...obj
                }
                that.$materialApi.postMaterialScreen(params).then(res => {
                    that.subLoading = false
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.cancelBtn()
                        that.$emit('affirm')
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            }
        },
        // 插入变量
		handleInputBlur(e) {
			this.cursorIndex = e.srcElement.selectionStart
		},
        getCursor(event) {
			if (this.cursorIndex == null) {
				return
			}
			var len = this.cursorIndex + 4
			event.target.setSelectionRange(len, len)
		},
        insertVariable(){
            var txt = JSON.parse(JSON.stringify(this.info.screen_text))
			this.info.screen_text = txt.slice(0, this.cursorIndex) + '[变量]' + txt.slice(this.cursorIndex, txt.length)
			this.$nextTick(() => {
				let ref = eval('this.$refs.txtInput')[0]
				ref.focus()
			})
			this.$forceUpdate()
        },
        // 上传图片成功返回
        successUpload(item){
            that.info.background_img = item.long_url
        },
        // 转换数字类型
        numFuntion(id){
            return id*1
        },
        // 预览图片
        playImg(url){
            this.$refs.img.openDialog(url)
        },
    }
}
</script>
<style lang='scss' scoped>
.classify_add_eidt{
    .main_info{
        width: 100%;
        .info_text{
            width: 100%;
            padding-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .t_left{
                // width: 80px;
                padding-right: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                text-align: right;
                span {
                    color: #e51d41;
                }
            }
            .t_right{
                position: relative;
                width: 355px;
                .el-input {
                    width: 100%;
                }

                .el-select {
                    width: 100%;
                }
                ::v-deep .el-textarea {
                    width: 100%;
                    .el-textarea__inner{
                        padding-bottom: 20px;
                    }
                }
                .input_btn{
                    position: absolute;
                    bottom: 5px;
                    left: 10px;
                    padding: 0px;
                    background: #fff;
                }
            }
        }
        .info_text:last-child{
            padding-bottom: 0;
        }
    }
}
.succ_btn{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    padding: 0 10px;
    border-radius: 5px;
    background: rgba($color: #000000, $alpha: 0.5);
    display: none;
    align-items: center;
    justify-content: space-around;
    i{
        font-size: 26px;
        color: #fff;
    }
}
.img_yes:hover .succ_btn{
    display: flex;
}
</style>